import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=f2af2362&scoped=true&"
import script from "./HomeAbout.vue?vue&type=script&lang=js&"
export * from "./HomeAbout.vue?vue&type=script&lang=js&"
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=f2af2362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af2362",
  null
  
)

export default component.exports